// GENERATED from the design's markup by scratchpad batchG/mkcrmview.mjs (tpl2jsx), then kept by hand.
// Design: Aithora ConsoleV3.dc.html T6744-7142 (the CRM workspace) and T7178-7352 (the contact and
// company drawers). Every value comes from `v` (useCrm.ts), which is built from the live routes.
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fragment } from 'react';
import { ErrorNote } from '../../../ErrorNote';
import { Skeleton } from '../../../ui/states';
import { ck, hov, pd, sx } from '../dc';
import type { CrmVals } from './useCrm';
import { DealExtras } from './DealExtras';
import { BAR, BulkPicker, ContactSmsConsent, InlineCell, LINK, OwnerCell, SELECT, UndoStrip, ViewStrip } from './CrmExtras';
import { LOST_REASONS } from './util';
import { BuildLabel, BuildTagged } from '../../../ui/buildLabels';

export function CrmView({ v }: { v: CrmVals }) {
  void pd;
  return (
    <>
          <div style={sx('height:calc(100vh - 176px);min-height:0;display:flex;flex-direction:column;gap:10px;')}>
            {!!(v.mxOpen) && (
              <>
                <div onClick={v.mxClose} style={sx('position:fixed;inset:0;z-index:90;background:rgba(34,39,46,.32);')} />
                {' '}
                <div style={sx('position:fixed;top:0;right:0;bottom:0;z-index:91;width:min(460px,92vw);background:#F7F3EA;box-shadow:-14px 0 40px rgba(34,39,46,.22);display:flex;flex-direction:column;animation:riseIn .25s cubic-bezier(.22,.61,.36,1);')}>
                  <div style={sx('display:flex;align-items:center;gap:10px;padding:16px 18px 12px;border-bottom:1px solid rgba(34,39,46,.12);')}>
                    <span style={sx('display:flex;flex-direction:column;gap:2px;flex:1 1 auto;min-width:0;')}>
                      <span style={sx('font-size:17px;font-weight:800;color:#22272E;')}>
                        Email &amp; calendar
                      </span>
                      <span style={sx('font-size:14px;color:#54606C;')}>
                        Your account only &middot; each salesperson connects their own
                      </span>
                    </span>
                    <a href="#" onClick={ck(v.mxClose)} style={sx('display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:7px;border:1px solid rgba(34,39,46,.18);font-size:16px;color:#22272E;text-decoration:none;')}>
                      &#10005;
                    </a>
                  </div>
                  {' '}
                  <div style={sx('flex:1 1 auto;min-height:0;overflow-y:auto;padding:14px 18px 18px;display:flex;flex-direction:column;gap:16px;')}>
                    {!!(v.mxNone) && (
                      <>
                        <div style={sx('display:flex;flex-direction:column;gap:9px;')}>
                          <span style={sx('font-size:16px;color:#22272E;line-height:1.55;text-wrap:pretty;')}>
                            Connect your @aithoracare.com inbox and calendar. Emails and meetings with anyone at a company in the CRM land on that company, its people and its deals automatically. Personal and internal mail is skipped.
                          </span>
                          {' '}
                          <div style={sx('display:flex;gap:8px;flex-wrap:wrap;')}>
                            <a href="#" onClick={ck(v.mxGoogle)} style={sx(v.mxBtnP)}>
                              Connect Google Workspace
                            </a>
                            <a href="#" onClick={ck(v.mxMicrosoft)} style={sx(v.mxBtnG)}>
                              Connect Microsoft 365
                            </a>
                          </div>
                          {' '}
                          <span style={sx('font-size:14px;color:#54606C;line-height:1.5;')}>
                            You sign in on Google&rsquo;s or Microsoft&rsquo;s own page. Aithora never sees your password. Until you connect, BCC deals@aithoracare.com still files any email.
                          </span>
                        </div>
                      </>
                    )}
                    {' '}
                    {!!(v.mxSyncing) && (
                      <>
                        <div style={sx('display:flex;flex-direction:column;gap:7px;')}>
                          <span style={sx('display:flex;align-items:baseline;gap:8px;')}>
                            <span style={sx('font-size:16px;font-weight:800;color:#22272E;')}>
                              Syncing
                            </span>
                            <span style={sx('font-size:16px;font-weight:700;color:#264C7E;font-variant-numeric:tabular-nums;')}>
                              <span>{v.mxPct}</span>
                            </span>
                          </span>
                          {' '}
                          <div style={sx('height:6px;border-radius:3px;background:rgba(34,39,46,.1);overflow:hidden;')}>
                            <span style={sx(v.mxBar)} />
                          </div>
                          {' '}
                          <span style={sx('font-size:16px;color:#54606C;line-height:1.5;')}>
                            <span>{v.mxSyncLine}</span>
                          </span>
                        </div>
                      </>
                    )}
                    {' '}
                    {!!(v.mxDone) && (
                      <>
                        <div style={sx('display:flex;flex-direction:column;gap:6px;')}>
                          <span style={sx('display:flex;align-items:center;gap:8px;')}>
                            <span style={sx('width:8px;height:8px;border-radius:4px;background:#2F8A6F;animation:pulse 2s ease-in-out infinite;')} />
                            <span style={sx('font-size:16px;font-weight:800;color:#12503C;')}>
                              In sync
                            </span>
                            <span style={sx('font-size:16px;color:#54606C;')}>
                              <span>{v.mxAcct}</span>
                            </span>
                          </span>
                          {' '}
                          <span style={sx('font-size:16px;color:#3C454F;line-height:1.5;')}>
                            <span>{v.mxSyncLine}</span>
                          </span>
                          {' '}
                          <span style={sx('font-size:14px;color:#54606C;line-height:1.5;')}>
                            New mail arrives within seconds; a catch-up runs every 10 minutes in case a notification is missed.
                          </span>
                          {' '}
                          <a href="#" onClick={ck(v.mxDisconnect)} style={sx('align-self:flex-start;font-size:16px;font-weight:700;color:#B3261E;text-decoration:none;')}>
                            Disconnect
                          </a>
                        </div>
                      </>
                    )}
                    {' '}
                    <div style={sx('display:flex;flex-direction:column;gap:7px;')}>
                      <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                        What teammates see
                      </span>
                      <div style={sx('display:flex;gap:4px;flex-wrap:wrap;')}>
                        {(v.mxShareOpts ?? []).map((o: any, o_i: number) => (
                          <Fragment key={o_i}>
                            <a href="#" onClick={ck(o.onClick)} style={sx(o.style)}>
                              <span>{o.n}</span>
                            </a>
                          </Fragment>
                        ))}
                      </div>
                      <span style={sx('font-size:16px;color:#3C454F;line-height:1.5;text-wrap:pretty;')}>
                        <span>{v.mxShareNote}</span>
                      </span>
                      <span style={sx('font-size:14px;color:#54606C;line-height:1.5;')}>
                        Mark any thread Private from the deal. Private calendar events never sync. Admins cannot open your email bodies.
                      </span>
                    </div>
                    {' '}
                    <div style={sx('display:flex;flex-direction:column;gap:7px;')}>
                      <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                        Never sync
                      </span>
                      {' '}
                      <div style={sx('display:flex;gap:5px;flex-wrap:wrap;')}>
                        {(v.mxBlock ?? []).map((b: any, b_i: number) => (
                          <Fragment key={b_i}>
                            <a href="#" onClick={ck(b.onRm)} style={sx('display:inline-flex;align-items:center;gap:5px;height:24px;padding:0 8px;border-radius:12px;font-size:14px;font-weight:600;text-decoration:none;color:#3C454F;background:rgba(34,39,46,.07);')}>
                              <span>{b.n}</span>{' '}
                              <span style={sx('font-size:14px;')}>
                                &#10005;
                              </span>
                            </a>
                          </Fragment>
                        ))}
                      </div>
                      {' '}
                      <div style={sx('display:flex;gap:6px;')}>
                        <input type="text" value={v.mxBlkIn} onChange={v.mxSetBlk} placeholder="Add a domain or address" style={sx('flex:1 1 auto;min-width:0;height:30px;box-sizing:border-box;padding:0 10px;border-radius:7px;border:1px solid rgba(34,39,46,.2);background:#FCFAF4;font:inherit;font-size:16px;color:#22272E;')} />
                        <a href="#" aria-disabled={!v.mxBlkIn.trim() || undefined} title={v.mxBlkIn.trim() ? undefined : 'Type a domain or address first'} onClick={ck(v.mxAddBlk)} style={sx('display:inline-flex;align-items:center;height:26px;padding:0 9px;border-radius:7px;font-size:14px;font-weight:700;text-decoration:none;white-space:nowrap;color:#22272E;border:1px solid rgba(34,39,46,.22);height:30px;')}>
                          Add
                        </a>
                      </div>
                      {' '}
                      <div style={sx('display:flex;gap:8px;align-items:flex-start;padding:8px 10px;border-radius:8px;background:rgba(179,38,30,.06);')}>
                        <span style={sx('font-size:14px;font-weight:800;letter-spacing:.07em;color:#8E2A1F;background:rgba(179,38,30,.12);border-radius:3px;padding:2px 5px;flex:0 0 auto;')}>
                          ALWAYS ON
                        </span>
                        <span style={sx('font-size:14px;color:#3C454F;line-height:1.5;')}>
                          Health-information guard. A thread that names a resident or carries clinical detail is not logged; you see a note on the deal instead. This cannot be turned off.
                        </span>
                      </div>
                    </div>
                    {' '}
                    {!!v.mxErr && (
                      <div role="alert" style={sx('font-size:16px;font-weight:700;color:#B3261E;line-height:1.5;')}>
                        <span>{v.mxErr}</span>
                      </div>
                    )}
                    {!!(v.mxQHas) && (
                      <>
                        <div style={sx('display:flex;flex-direction:column;gap:6px;')}>
                          <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                            Match these senders
                          </span>
                          <span style={sx('font-size:14px;color:#54606C;')}>
                            <span>{v.mxQLine}</span>. Nothing is logged for them until you decide.
                          </span>
                          {' '}
                          {(v.mxQRows ?? []).map((q: any, q_i: number) => (
                            <Fragment key={q_i}>
                              <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:wrap;row-gap:5px;padding:7px 0;border-top:1px solid rgba(34,39,46,.08);')}>
                                <span style={sx('display:flex;flex-direction:column;gap:1px;min-width:0;flex:1 1 180px;')}>
                                  <span style={sx('font-size:16px;font-weight:600;color:#22272E;overflow-wrap:break-word;')}>
                                    <span>{q.from}</span>
                                  </span>
                                  <span style={sx('font-size:14px;color:#54606C;')}>
                                    <span>{q.hint}</span>
                                  </span>
                                </span>
                                {!!(q.hasSug) && (
                                  <>
                                    <a href="#" onClick={ck(q.onLink)} style={sx('display:inline-flex;align-items:center;height:26px;padding:0 9px;border-radius:7px;font-size:14px;font-weight:700;text-decoration:none;white-space:nowrap;color:#fff;background:#2F5C97;')}>
                                      <span>{q.sug}</span>
                                    </a>
                                  </>
                                )}
                                <a href="#" onClick={ck(q.onIgnore)} style={sx('display:inline-flex;align-items:center;height:26px;padding:0 9px;border-radius:7px;font-size:14px;font-weight:700;text-decoration:none;white-space:nowrap;color:#22272E;border:1px solid rgba(34,39,46,.22);')}>
                                  Don&rsquo;t log
                                </a>
                              </div>
                            </Fragment>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
            {' '}
            <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:nowrap;min-width:0;')}>
              <span style={sx('position:relative;flex:1 1 auto;min-width:0;display:flex;')}>
                <input type="text" value={v.crmQ} onChange={v.crmSetQ} onKeyDown={v.crmQKey} placeholder={v.crmQPh} style={sx('flex:1 1 auto;min-width:0;height:34px;box-sizing:border-box;padding:0 12px 0 32px;border-radius:9px;border:1px solid rgba(34,39,46,.22);background:#FCFAF4;font:inherit;font-size:16px;color:#22272E;')} />
                {' '}
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#54606C" strokeWidth="2" strokeLinecap="round" style={sx('position:absolute;left:11px;top:10px;')}>
                  <circle cx="11" cy="11" r="7" />
                  <path d="M20 20l-3.5-3.5" />
                </svg>
              </span>
              {' '}
              {!!(v.crmIsCatalog) && (
                <>
                  <a href="#" aria-disabled={!v.crmQ.trim() || undefined} title={v.crmQ.trim() ? undefined : 'Type what you are looking for first'} onClick={ck(v.crmAsk)} style={sx('display:inline-flex;align-items:center;height:34px;padding:0 13px;border-radius:9px;font-size:16px;font-weight:700;text-decoration:none;white-space:nowrap;color:#fff;background:#2F5C97;')}>
                    Search
                  </a>
                </>
              )}
              {' '}
              {!!(v.crmModeShow) && (
                <>
                  <span style={sx('display:flex;gap:2px;padding:2px;border-radius:8px;border:1px solid rgba(34,39,46,.14);flex:0 0 auto;')}>
                    {(v.crmModes ?? []).map((m: any, m_i: number) => (
                      <Fragment key={m_i}>
                        <a href="#" onClick={ck(m.onClick)} style={sx(m.style)}>
                          <span>{m.n}</span>
                        </a>
                      </Fragment>
                    ))}
                  </span>
                </>
              )}
              {' '}
              <a href="#" onClick={ck(v.mxOpenBtn)} style={sx(v.mxChipStyle)}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path d="M3 7l9 6 9-6" />
                </svg>
                <span>{v.mxChip}</span>
              </a>
              {' '}
              <a href="#" onClick={ck(v.crmNewDeal)} style={sx('display:inline-flex;align-items:center;height:34px;padding:0 12px;border-radius:9px;font-size:16px;font-weight:700;text-decoration:none;white-space:nowrap;color:#22272E;border:1px solid rgba(34,39,46,.22);flex:0 0 auto;')}>
                + New deal
              </a>
            </div>
            {!!v.actErr && (
              <div role="alert" style={sx('font-size:14px;font-weight:700;color:#B3261E;')}>
                <span>{v.actErr}</span>
              </div>
            )}
            {!!v.loadError && <ErrorNote error={v.loadError} onRetry={v.reloadAll} compact />}
            {' '}
            <div ref={v.crmGridRef} style={sx(v.crmGridStyle)}>
              <div style={sx('min-width:0;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:1px;border-right:1px solid rgba(34,39,46,.12);padding-right:8px;')}>
                {(v.crmRail ?? []).map((rv: any, rv_i: number) => (
                  <Fragment key={rv_i}>
                    <a href="#" onClick={ck(rv.onClick)} style={sx(rv.style)} className={hov('background:rgba(34,39,46,.05);')}>
                      <span style={sx('min-width:0;flex:1 1 auto;overflow-wrap:break-word;')}>
                        <span>{rv.n}</span>
                      </span>
                      <span style={sx('font-size:14px;font-variant-numeric:tabular-nums;color:#54606C;')}>
                        <span>{rv.c}</span>
                      </span>
                    </a>
                  </Fragment>
                ))}
                {' '}
                <div style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;padding:12px 8px 4px;')}>
                  Saved views
                </div>
                {' '}
                {(v.crmSavedList ?? []).map((rv: any, rv_i: number) => (
                  <Fragment key={rv_i}>
                    <a href="#" onClick={ck(rv.onClick)} style={sx(rv.style)} className={hov('background:rgba(34,39,46,.05);')}>
                      <span style={sx('min-width:0;flex:1 1 auto;overflow-wrap:break-word;')}>
                        <span>{rv.n}</span>
                      </span>
                      <span style={sx('font-size:14px;color:#54606C;')}>
                        <span>{rv.scope}</span>
                      </span>
                    </a>
                  </Fragment>
                ))}
              </div>
              {' '}
              <div style={sx('min-width:0;min-height:0;display:flex;flex-direction:column;overflow:hidden;')}>
                {!!(v.crmIsToday) && (
                  <>
                    <div style={sx('flex:1 1 auto;min-width:0;min-height:0;display:flex;flex-direction:column;gap:6px;')}>
                      <div style={sx('flex:0 0 auto;display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:1px;background:rgba(34,39,46,.1);border-radius:9px;overflow:hidden;')}>
                        {(v.crmDashK ?? []).map((k: any, k_i: number) => (
                          <Fragment key={k_i}>
                            <div style={sx('background:#FCFAF4;padding:7px 10px;min-width:0;display:flex;flex-direction:column;gap:1px;')}>
                              <span style={sx('font-size:14px;color:#54606C;overflow-wrap:break-word;')}>
                                <span>{k.k}</span>
                              </span>
                              <span style={sx('display:flex;align-items:center;gap:2px 6px;flex-wrap:wrap;min-width:0;')}>
                                <span style={sx(`${k.vStyle}white-space:nowrap;`)}>
                                  <span>{k.v}</span>
                                </span>
                                {!!(k.hasBadge) && (
                                  <>
                                    <BuildTagged tag={k.badge}><span style={sx('font-size:14px;font-weight:800;letter-spacing:.07em;color:#2F5C97;background:rgba(79,138,214,.13);border-radius:4px;padding:1px 5px;')}>
                                      <span>{k.badge}</span>
                                    </span></BuildTagged>
                                  </>
                                )}
                              </span>
                            </div>
                          </Fragment>
                        ))}
                      </div>
                      {' '}
                      <div style={sx('flex:0 0 auto;display:flex;align-items:stretch;gap:4px;min-width:0;')}>
                        {(v.crmDashFlow ?? []).map((f: any, f_i: number) => (
                          <Fragment key={f_i}>
                            <a href="#" onClick={ck(f.onClick)} title={f.title} style={sx(f.style)} className={hov('background:rgba(47,92,151,.08);')}>
                              <span style={sx('display:flex;align-items:baseline;flex-wrap:wrap;gap:0 6px;min-width:0;')}>
                                <span style={sx('font-size:14px;font-weight:700;white-space:nowrap;')}>
                                  <span>{f.n}</span>
                                </span>
                                <span style={sx('margin-left:auto;font-size:16px;font-weight:800;font-variant-numeric:tabular-nums;')}>
                                  <span>{f.c}</span>
                                </span>
                              </span>
                              <span style={sx('display:block;height:4px;border-radius:2px;background:rgba(34,39,46,.08);')}>
                                <span style={sx(f.bar)} />
                              </span>
                            </a>
                          </Fragment>
                        ))}
                        {' '}
                        <span title={v.crmDashFlowNote} style={sx('flex:0 0 auto;display:flex;align-items:center;padding:0 6px;font-size:14px;color:#54606C;white-space:nowrap;gap:4px;')}>
                          Lost{' '}
                          <b style={sx('color:#22272E;font-variant-numeric:tabular-nums;')}>
                            <span>{v.crmDashFlowLost}</span>
                          </b>
                        </span>
                      </div>
                      {' '}
                      <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:nowrap;white-space:nowrap;')}>
                        <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;flex:0 0 auto;')}>
                          Today
                        </span>
                        {' '}
                        <span style={sx('font-size:16px;color:#54606C;min-width:0;flex:0 1 auto;white-space:normal;overflow-wrap:break-word;')}>
                          <span>{v.crmTodayHead}</span>
                        </span>
                        {' '}
                        <span style={sx('flex:1;')} />
                        {' '}
                        {(v.crmScopeTabs ?? []).map((x: any, x_i: number) => (
                          <Fragment key={x_i}>
                            <a href="#" onClick={ck(x.onClick)} style={sx(x.style)}>
                              <span>{x.n}</span>
                            </a>
                          </Fragment>
                        ))}
                      </div>
                      {' '}
                      <div style={sx('flex:1 1 auto;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:2px;')}>
                        {!!(v.mxWaitHas) && (
                          <>
                            <div style={sx('display:flex;flex-direction:column;gap:2px;padding-bottom:6px;margin-bottom:4px;border-bottom:1px solid rgba(34,39,46,.1);')}>
                              <div style={sx('display:flex;align-items:baseline;gap:8px;padding:4px 11px 2px;')}>
                                <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                                  Waiting on reply
                                </span>
                                <span style={sx('font-size:14px;color:#54606C;')}>
                                  <span>{v.mxWaitHead}</span>{' '}&middot; from your synced inbox
                                </span>
                              </div>
                              {' '}
                              {(v.mxWaitRows ?? []).map((w: any, w_i: number) => (
                                <Fragment key={w_i}>
                                  <div style={sx('display:flex;align-items:center;gap:10px;flex-wrap:wrap;row-gap:4px;padding:6px 11px;border-radius:9px;animation:riseIn .28s cubic-bezier(.22,.61,.36,1) both;')} className={hov('background:rgba(34,39,46,.04);')}>
                                    <span style={sx('min-width:0;flex:1 1 240px;display:flex;flex-direction:column;gap:1px;')}>
                                      <span style={sx('display:flex;align-items:baseline;gap:8px;min-width:0;')}>
                                        <span style={sx(w.kStyle)}>
                                          <span>{w.kind}</span>{' '}&middot;{' '}<span>{w.age}</span>
                                        </span>
                                        <span style={sx('font-size:16px;font-weight:600;color:#22272E;overflow-wrap:break-word;')}>
                                          <span>{w.who}</span>
                                        </span>
                                      </span>
                                      <span style={sx('font-size:14px;color:#54606C;overflow-wrap:break-word;')}>
                                        <span>{w.co}</span>{' '}&middot;{' '}<span>{w.subj}</span>
                                      </span>
                                    </span>
                                    {' '}
                                    <span style={sx('display:flex;gap:5px;flex:0 0 auto;')}>
                                      <a href={w.mail} style={sx(w.prim)}>
                                        Reply
                                      </a>
                                      <a href="#" onClick={ck(w.onSnooze)} style={sx(w.ghost)}>
                                        Snooze 2d
                                      </a>
                                      <a href="#" onClick={ck(w.onDone)} style={sx(w.ghost)}>
                                        Done
                                      </a>
                                    </span>
                                  </div>
                                </Fragment>
                              ))}
                              {' '}
                              {!!(v.mxQHas) && (
                                <>
                                  <a href="#" onClick={ck(v.mxOpenBtn)} style={sx('display:block;padding:6px 11px;border-radius:9px;font-size:16px;color:#264C7E;text-decoration:none;font-weight:700;overflow-wrap:break-word;')} className={hov('background:rgba(79,138,214,.08);')}>
                                    <span>{v.mxQLine}</span>{' '}&middot; Review &rarr;
                                  </a>
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {' '}
                        {!!(v.mxNoWait) && (
                          <>
                            {!!(v.crmTodayNone) && (
                              <>
                                <div style={sx('flex:0 0 auto;padding:10px 11px 6px;font-size:16px;color:#54606C;line-height:1.5;')}>
                                  Nothing is waiting on you. Start a deal from the list below or from Territory, and it shows up here with its next step.
                                </div>
                                {' '}
                                <div style={sx('flex:0 0 auto;display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:1px;background:rgba(34,39,46,.1);border-radius:8px;overflow:hidden;margin:0 11px 8px;')}>
                                  {(v.crmActWeek ?? []).map((w: any, w_i: number) => (
                                    <Fragment key={w_i}>
                                      <div style={sx('background:#FCFAF4;padding:7px 10px;min-width:0;display:flex;flex-direction:column;gap:1px;')}>
                                        <span style={sx('font-size:14px;color:#54606C;overflow-wrap:break-word;')}>
                                          <span>{w.k}</span>
                                        </span>
                                        <span style={sx('font-size:16px;font-weight:800;font-variant-numeric:tabular-nums;color:#22272E;')}>
                                          <span>{w.v}</span>
                                        </span>
                                        <span style={sx('font-size:14px;color:#54606C;overflow-wrap:break-word;')}>
                                          <span>{w.sub}</span>
                                        </span>
                                      </div>
                                    </Fragment>
                                  ))}
                                </div>
                              </>
                            )}
                          </>
                        )}
                        {' '}
                        {!!v.loading && <Skeleton rows={4} label="Loading My day" />}
                        {(v.crmTodayRows ?? []).map((r: any, r_i: number) => (
                          <Fragment key={r_i}>
                            <div onClick={r.onSel} style={sx(r.style)} className={hov('background:rgba(79,138,214,.07);')}>
                              <div style={sx('display:flex;align-items:center;gap:8px;min-width:0;')}>
                                <span style={sx('font-size:16px;font-weight:700;color:#22272E;min-width:0;flex:1 1 auto;overflow-wrap:break-word;')}>
                                  <span translate="no">{r.name}</span>
                                </span>
                                {' '}
                                <span style={sx(r.stageStyle)}>
                                  <span>{r.stage}</span>
                                </span>
                                {' '}
                                {!!(r.hasAmt) && (
                                  <>
                                    <span style={sx('font-size:16px;font-weight:700;font-variant-numeric:tabular-nums;color:#22272E;white-space:nowrap;')}>
                                      <span>{r.amount}</span>
                                    </span>
                                    {!!r.modeled && (
                                      <BuildLabel><span style={sx('font-size:14px;font-weight:800;letter-spacing:.07em;color:#264C7E;background:rgba(47,92,151,.12);border-radius:3px;padding:1px 4px;')}>
                                        MODELED
                                      </span></BuildLabel>
                                    )}
                                  </>
                                )}
                              </div>
                              {' '}
                              <div style={sx('display:flex;align-items:center;gap:8px;min-width:0;')}>
                                {!!(r.hasMeet) && (
                                  <>
                                    <a href="#" onClick={ck(r.onMp)} style={sx(r.meetStyle)}>
                                      <span>{r.meetLabel}</span>
                                    </a>
                                  </>
                                )}
                                {' '}
                                <span style={sx(r.lastStyle)}>
                                  <span>{r.last}</span>
                                </span>
                                {' '}
                                <span style={sx('font-size:14px;color:#3C454F;min-width:0;flex:1 1 auto;overflow-wrap:break-word;')}>
                                  <span>{r.next}</span>
                                </span>
                              </div>
                              {' '}
                              <div style={sx('display:flex;align-items:center;gap:8px;min-width:0;')}>
                                <span style={sx('display:flex;gap:4px;flex-wrap:nowrap;white-space:nowrap;min-width:0;')}>
                                  <a href={r.mail} onClick={r.onEmail} style={sx(r.ghost)}>
                                    Email
                                  </a>
                                  {' '}
                                  <a href="#" onClick={ck(r.onCall)} style={sx(r.ghost)}>
                                    Log call
                                  </a>
                                  {' '}
                                  <a href="#" onClick={ck(r.onSnooze)} style={sx(r.ghost)}>
                                    Snooze 3d
                                  </a>
                                  {' '}
                                  <a href="#" onClick={ck(r.onAdvance)} title={r.advTitle} style={sx(r.advStyle)}>
                                    <span>{r.advLabel}</span>
                                  </a>
                                </span>
                              </div>
                            </div>
                          </Fragment>
                        ))}
                        {' '}
                        {!!(v.crmProsHas) && (
                          <>
                            <div style={sx('display:flex;align-items:center;gap:8px;padding:10px 11px 4px;')}>
                              <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                                Not started yet
                              </span>
                              <span style={sx('font-size:14px;color:#54606C;')}>
                                top prospects by open dollars
                              </span>
                            </div>
                            {' '}
                            {(v.crmPros ?? []).map((p: any, p_i: number) => (
                              <Fragment key={p_i}>
                                <div style={sx(p.style)} className={hov('background:rgba(34,39,46,.04);')}>
                                  <span style={sx('min-width:0;flex:1 1 auto;display:flex;flex-direction:column;gap:1px;')}>
                                    <span style={sx('font-size:16px;font-weight:600;color:#22272E;overflow-wrap:break-word;')}>
                                      <span translate="no">{p.name}</span>
                                    </span>
                                    <span style={sx('font-size:14px;color:#54606C;overflow-wrap:break-word;')}>
                                      <span>{p.meta}</span>
                                    </span>
                                  </span>
                                  {' '}
                                  <span style={sx('font-size:16px;font-weight:700;font-variant-numeric:tabular-nums;white-space:nowrap;')}>
                                    <span>{p.amount}</span>
                                  </span>
                                  {' '}
                                  {!!p.modeled && (
                                    <BuildLabel><span style={sx('font-size:14px;font-weight:800;letter-spacing:.07em;color:#264C7E;background:rgba(47,92,151,.12);border-radius:3px;padding:1px 4px;')}>
                                      MODELED
                                    </span></BuildLabel>
                                  )}
                                  {' '}
                                  <a href="#" onClick={ck(p.onStart)} style={sx(p.ghost)}>
                                    + Start deal
                                  </a>
                                </div>
                              </Fragment>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {' '}
                {!!(v.crmIsDeals) && (
                  <>
                    <div style={sx('display:flex;align-items:center;gap:8px;padding-bottom:6px;flex-wrap:wrap;row-gap:4px;')}>
                      <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                        <span>{v.crmVName}</span>
                      </span>
                      {' '}
                      <span style={sx('font-size:16px;color:#54606C;')}>
                        <span>{v.crmDealCount}</span>
                      </span>
                      {/* Restored from production: the deals as CSV. */}
                      <a href="#" onClick={ck(v.crmDealExport)} style={sx('font-size:16px;font-weight:600;color:#2F5C97;text-decoration:none;')}>Export CSV</a>
                      {/* crm-extras: owner and tag filters, and the columns shown (only once there are deals). */}
                      {!!v.crmDealTools && (
                        <>
                          <select aria-label="Owner filter" value={v.crmDealOwnerF} onChange={v.crmDealSetOwnerF} style={sx(SELECT)}>
                            {(v.crmDealOwnerOpts ?? []).map((o: any) => <option key={o.v} value={o.v}>{o.n}</option>)}
                          </select>
                          <select aria-label="Tag filter" value={v.crmDealTagF} onChange={v.crmDealSetTagF} style={sx(SELECT)}>
                            {(v.crmDealTagOpts ?? []).map((o: any) => <option key={o.v} value={o.v}>{o.n}</option>)}
                          </select>
                          <span style={sx('position:relative;display:inline-flex;')}>
                            <a href="#" aria-expanded={v.crmDealColsOpen} onClick={ck(v.crmDealColsToggle)} style={sx(LINK)}>Columns</a>
                            {!!v.crmDealColsOpen && (
                              <span role="group" aria-label="Columns" style={sx('position:absolute;top:22px;left:0;z-index:5;display:flex;flex-direction:column;gap:4px;padding:8px 10px;border-radius:9px;background:#FCFAF4;border:1px solid rgba(34,39,46,.16);box-shadow:0 8px 24px rgba(34,39,46,.14);white-space:nowrap;')}>
                                {(v.crmDealColChoices ?? []).map((c: any) => (
                                  <label key={c.n} style={sx('display:flex;align-items:center;gap:6px;font-size:16px;color:#22272E;cursor:pointer;')}>
                                    <input type="checkbox" checked={c.on} onChange={c.onChange} />
                                    {c.n}
                                  </label>
                                ))}
                              </span>
                            )}
                          </span>
                        </>
                      )}
                      {' '}
                      {!!(v.crmGateHas) && (
                        <>
                          <span style={sx('font-size:14px;font-weight:700;color:#B3261E;')}>
                            <span>{v.crmGateMsg}</span>
                          </span>
                        </>
                      )}
                    </div>
                    {!!v.crmDealTools && (
                      <ViewStrip client={v.crmClient} canWrite={v.crmCanWrite} userId={v.crmUserId} isManager={v.crmIsManager} {...v.crmDealView} />
                    )}
                    {v.crmDealSelN > 0 ? (
                      <div data-testid="crm-deal-bulk" style={sx(BAR)}>
                        <span style={sx('font-size:16px;font-weight:700;color:#264C7E;')}>{v.crmDealSelLine}</span>
                        {(v.crmDealBulk ?? []).map((b: any) => (
                          <a key={b.n} href="#" aria-pressed={b.on} onClick={ck(b.onClick)} style={sx(b.style)}>{b.n}</a>
                        ))}
                        {!!v.crmDealBulkKind && (
                          <BulkPicker
                            key={v.crmDealBulkKind}
                            kind={v.crmDealBulkKind}
                            options={v.crmDealBulkOptions}
                            lostIds={v.crmDealBulkLostIds}
                            lostReasons={LOST_REASONS}
                            busy={v.crmDealBulkBusy}
                            onApply={v.crmDealBulkApply}
                            onCancel={v.crmDealBulkCancel}
                          />
                        )}
                        <span style={sx('flex:1;')} />
                        <a href="#" onClick={ck(v.crmDealClearSel)} style={sx('font-size:14px;font-weight:600;color:#54606C;text-decoration:none;')}>Clear</a>
                      </div>
                    ) : (
                      <UndoStrip toast={v.crmDealToast} busy={v.crmDealBulkBusy} onUndo={v.crmDealUndo} onDismiss={v.crmDealToastDismiss} />
                    )}
                    {' '}
                    <div onKeyDown={v.crmDealKeys} tabIndex={v.crmDealHasRows ? 0 : undefined} aria-label={v.crmDealHasRows ? 'Deals. Ctrl or Cmd+A selects all, Esc clears.' : undefined} style={sx('flex:1 1 auto;min-height:0;overflow:auto;outline:none;')}>
                      <div role={v.crmDealHasRows ? 'grid' : undefined} aria-multiselectable={v.crmDealHasRows || undefined} style={sx('min-width:820px;')}>
                        <div role={v.crmDealHasRows ? 'row' : undefined} style={sx(v.crmDealHeadStyle)}>
                          {(v.crmDealHead ?? []).map((h: any, h_i: number) => (
                            <span key={h.key} role={v.crmDealHasRows ? 'columnheader' : undefined} aria-sort={h.ariaSort} style={sx(h_i === 0 && v.crmDealHasRows ? 'display:flex;align-items:center;gap:6px;min-width:0;' : '')}>
                              {h_i === 0 && !!v.crmDealHasRows && (
                                <a href="#" role="checkbox" aria-checked={v.crmDealSelAllMark === '☑'} aria-label="Select all deals shown" onClick={ck(v.crmDealSelAll)} style={sx('font-size:16px;color:#2F5C97;text-decoration:none;letter-spacing:0;')}>
                                  {v.crmDealSelAllMark}
                                </a>
                              )}
                              {h.onClick ? (
                                <a href="#" onClick={ck(h.onClick)} style={sx('color:inherit;text-decoration:none;')}>{h.n}</a>
                              ) : (
                                h.n
                              )}
                            </span>
                          ))}
                        </div>
                        {' '}
                        {!!(v.crmDealNone) && (
                          <>
                            <div style={sx('padding:14px 10px;font-size:16px;color:#54606C;')}>
                              <span>{v.crmDealNoneNote}</span>
                            </div>
                          </>
                        )}
                        {' '}
                        {(v.crmDealRows ?? []).map((r: any) => (
                          <Fragment key={r.id}>
                            <div role="row" aria-selected={r.sel} onClick={r.onSel} style={sx(r.style)} className={hov('background:rgba(79,138,214,.06);')}>
                              {(r.cols as string[]).map((c) => {
                                if (c === 'facility') {
                                  return (
                                    <span key={c} style={sx('display:flex;align-items:center;gap:6px;min-width:0;')}>
                                      <a href="#" role="checkbox" aria-checked={r.sel} aria-label={'Select ' + r.name} onClick={r.onMark} style={sx('font-size:16px;color:#2F5C97;text-decoration:none;flex:0 0 auto;')}>
                                        {r.selMark}
                                      </a>
                                      <span style={sx('font-size:16px;font-weight:700;color:#22272E;min-width:0;overflow-wrap:break-word;')}>
                                        <span translate="no">{r.name}</span>
                                      </span>
                                    </span>
                                  );
                                }
                                if (c === 'stage') {
                                  return (
                                    <select key={c} value={r.stage} onChange={r.onStage} onClick={r.stop} disabled={r.disabled} title={r.writeTitle} aria-label={'Stage of ' + r.name} style={sx('height:28px;box-sizing:border-box;padding:0 6px;border-radius:7px;border:1px solid rgba(34,39,46,.2);background:#FCFAF4;font:inherit;font-size:16px;color:#22272E;')}>
                                      {(r.opts ?? []).map((o: any, o_i: number) => (
                                        <Fragment key={o_i}>
                                          <option value={o.v}>
                                            <span>{o.n}</span>
                                          </option>
                                        </Fragment>
                                      ))}
                                    </select>
                                  );
                                }
                                if (c === 'owner') {
                                  return (
                                    <OwnerCell key={c} display={r.owner} ownerId={r.ownerId} members={v.crmMembers ?? []} editable={r.ownerEditable} claimOnly={r.ownerClaimOnly} userId={v.crmUserId} style="font-size:16px;color:#3C454F;" onChange={r.onOwner} />
                                  );
                                }
                                if (c === 'value') {
                                  return (
                                    <InlineCell key={c} display={r.value} value={r.valueRaw} type="number" label={'Value of ' + r.name + ' in dollars per year'} editable={r.editable} title={r.writeTitle} style="display:flex;align-items:center;gap:4px;font-size:16px;font-weight:700;font-variant-numeric:tabular-nums;white-space:nowrap;" onCommit={r.onValue} />
                                  );
                                }
                                if (c === 'last') {
                                  return (
                                    <span key={c} style={sx(r.lastStyle)}>
                                      <span>{r.last}</span>
                                    </span>
                                  );
                                }
                                if (c === 'next') {
                                  return (
                                    <span key={c} style={sx('font-size:14px;color:#3C454F;min-width:0;overflow-wrap:break-word;')}>
                                      <span>{r.next}</span>
                                    </span>
                                  );
                                }
                                if (c === 'meet') {
                                  return (
                                    <InlineCell key={c} display={r.meet} value={r.meetRaw} type="date" label={'Next meeting for ' + r.name} editable={r.editable} title={r.writeTitle} style="font-size:14px;color:#3C454F;font-variant-numeric:tabular-nums;" onCommit={r.onMeet} />
                                  );
                                }
                                return (
                                  <span key={c} style={sx('font-size:14px;color:#3C454F;min-width:0;overflow-wrap:break-word;font-variant-numeric:tabular-nums;')}>
                                    <span>{c === 'tags' ? r.tags : r.close}</span>
                                  </span>
                                );
                              })}
                            </div>
                          </Fragment>
                        ))}
                      </div>
                    </div>
                  </>
                )}
                {' '}
                {!!(v.crmIsCatalog) && (
                  <>
                    <div style={sx('display:flex;align-items:center;gap:6px;flex-wrap:wrap;row-gap:5px;padding-bottom:6px;')}>
                      <span style={sx('display:inline-flex;gap:4px;margin-right:4px;')}>
                        {(v.cKinds ?? []).map((k: any, k_i: number) => (
                          <Fragment key={k_i}>
                            <a href="#" onClick={ck(k.onClick)} style={sx(k.style)}>
                              <span>{k.n}</span>
                              <span style={sx('font-weight:600;opacity:.8;font-variant-numeric:tabular-nums;')}>
                                <span>{k.c}</span>
                              </span>
                            </a>
                          </Fragment>
                        ))}
                      </span>
                      {' '}
                      {(v.cChips ?? []).map((c: any, c_i: number) => (
                        <Fragment key={c_i}>
                          <a href="#" onClick={ck(c.onClick)} style={sx('display:inline-flex;align-items:center;gap:5px;height:24px;padding:0 8px;border-radius:12px;font-size:14px;font-weight:600;text-decoration:none;white-space:nowrap;color:#264C7E;background:rgba(79,138,214,.14);')}>
                            <span>{c.n}</span>{' '}
                            <span style={sx('font-size:14px;')}>
                              &#10005;
                            </span>
                          </a>
                        </Fragment>
                      ))}
                      {' '}
                      <a href="#" onClick={ck(v.cToggleF)} style={sx('display:inline-flex;align-items:center;height:24px;padding:0 9px;border-radius:12px;font-size:14px;font-weight:700;text-decoration:none;white-space:nowrap;color:#22272E;border:1px dashed rgba(34,39,46,.3);')}>
                        + Filter
                      </a>
                      {' '}
                      {!!(v.cHasChips) && (
                        <>
                          <a href="#" onClick={ck(v.cClear)} style={sx('font-size:14px;font-weight:600;color:#54606C;text-decoration:none;')}>
                            Clear all
                          </a>
                        </>
                      )}
                      {' '}
                      <span style={sx('flex:1;')} />
                      {' '}
                      <span style={sx('font-size:14px;color:#54606C;white-space:nowrap;')}>
                        <span>{v.cCountLine}</span>
                      </span>
                      {/* Restored from production: track facilities from a CSV (id, ccn or npi column). */}
                      <input ref={v.cImportRef} type="file" accept=".csv,text/csv" hidden aria-label="Companies CSV" onChange={v.cOnImportFile} />
                      <a href="#" aria-disabled={!v.cCanImport || undefined} onClick={ck(v.cImport)} style={sx('font-size:14px;font-weight:600;color:' + (v.cCanImport ? '#2F5C97' : '#54606C') + ';text-decoration:none;white-space:nowrap;')}>Import CSV</a>
                    </div>
                    {!!v.cImportNote && <div role="status" style={sx('font-size:14px;color:#3C454F;padding:2px 0;')}>{v.cImportNote}</div>}
                    {' '}
                    {!!(v.cFOpen) && (
                      <>
                        <div style={sx('display:flex;align-items:center;gap:6px;flex-wrap:wrap;row-gap:6px;padding:8px 10px;margin-bottom:6px;border-radius:9px;background:#FCFAF4;border:1px solid rgba(34,39,46,.12);')}>
                          {(v.cFacets ?? []).map((f: any, f_i: number) => (
                            <Fragment key={f_i}>
                              <label style={sx('display:flex;align-items:center;gap:4px;font-size:14px;color:#54606C;')}>
                                <span>{f.n}</span>
                                <select value={f.val} onChange={f.onChange} style={sx('height:28px;box-sizing:border-box;padding:0 6px;border-radius:7px;border:1px solid rgba(34,39,46,.2);background:#FCFAF4;font:inherit;font-size:16px;color:#22272E;')}>
                                  {(f.opts ?? []).map((o: any, o_i: number) => (
                                    <Fragment key={o_i}>
                                      <option value={o.v}>
                                        <span>{o.n}</span>
                                      </option>
                                    </Fragment>
                                  ))}
                                </select>
                              </label>
                            </Fragment>
                          ))}
                          {' '}
                          <span style={sx('flex:1;')} />
                          {' '}
                          <input type="text" value={v.cSaveName} onChange={v.cSetSaveName} placeholder="Name this view" style={sx('height:28px;box-sizing:border-box;padding:0 6px;border-radius:7px;border:1px solid rgba(34,39,46,.2);background:#FCFAF4;font:inherit;font-size:16px;color:#22272E;width:150px;')} />
                          {' '}
                          <a href="#" onClick={ck(v.cSave)} style={sx('display:inline-flex;align-items:center;height:28px;padding:0 10px;border-radius:7px;font-size:16px;font-weight:700;text-decoration:none;white-space:nowrap;color:#fff;background:#2F5C97;')}>
                            Save view
                          </a>
                        </div>
                      </>
                    )}
                    {' '}
                    {/* crm-extras: the open saved company view (Edited, Save, Save as new, Reset, share, default). */}
                    {!v.cIsOps && <ViewStrip client={v.crmClient} canWrite={v.crmCanWrite} userId={v.crmUserId} isManager={v.crmIsManager} {...v.cView} />}
                    {!v.cHasSel && <UndoStrip toast={v.cToast} busy={v.cBulkBusy} onUndo={v.cUndo} onDismiss={v.cToastDismiss} />}
                    {!!(v.cHasSel) && (
                      <>
                        <div style={sx('display:flex;align-items:center;gap:6px;flex-wrap:wrap;row-gap:5px;padding:6px 10px;margin-bottom:6px;border-radius:9px;background:rgba(79,138,214,.1);')}>
                          <span style={sx('font-size:16px;font-weight:700;color:#264C7E;')}>
                            <span>{v.cSelLine}</span>
                          </span>
                          {' '}
                          {(v.cBulk ?? []).map((b: any, b_i: number) => (
                            <Fragment key={b_i}>
                              <a href="#" onClick={ck(b.onClick)} style={sx('display:inline-flex;align-items:center;height:26px;padding:0 9px;border-radius:7px;font-size:14px;font-weight:700;text-decoration:none;white-space:nowrap;color:#22272E;border:1px solid rgba(34,39,46,.2);background:#FCFAF4;')}>
                                <span>{b.n}</span>
                              </a>
                            </Fragment>
                          ))}
                          {/* crm-extras: tag, status and owner on the selected companies. */}
                          {(v.cBulkMore ?? []).map((b: any) => (
                            <a key={b.n} href="#" onClick={ck(b.onClick)} style={sx(b.style)}>{b.n}</a>
                          ))}
                          {!!v.cBulkKind && (
                            <BulkPicker key={v.cBulkKind} kind={v.cBulkKind} options={v.cBulkOptions} busy={v.cBulkBusy} onApply={v.cBulkApply} onCancel={v.cBulkCancel} />
                          )}
                          {' '}
                          <span style={sx('flex:1;')} />
                          {' '}
                          <a href="#" onClick={ck(v.cClearSel)} style={sx('font-size:14px;font-weight:600;color:#54606C;text-decoration:none;')}>
                            Clear
                          </a>
                        </div>
                      </>
                    )}
                    {' '}
                    <div style={sx('flex:1 1 auto;min-height:0;overflow:auto;')}>
                      <div style={sx('min-width:840px;')}>
                        <div style={sx(v.cHeadStyle)}>
                          <a href="#" onClick={ck(v.cSelAll)} style={sx('font-size:16px;color:#54606C;text-decoration:none;overflow:hidden;')}>
                            <span>{v.cSelAllMark}</span>
                          </a>
                          {' '}
                          {(v.cHead ?? []).map((h: any, h_i: number) => (
                            <Fragment key={h_i}>
                              <a href="#" onClick={ck(h.onClick)} style={sx('font-size:14px;letter-spacing:.08em;text-transform:uppercase;color:#54606C;font-weight:700;text-decoration:none;overflow-wrap:break-word;')}>
                                <span>{h.n}</span>
                              </a>
                            </Fragment>
                          ))}
                        </div>
                        {' '}
                        {!!(v.cNone) && (
                          <>
                            <div style={sx('padding:14px 10px;font-size:16px;color:#54606C;')}>
                              Nothing matches. Loosen a filter, or clear all.
                            </div>
                          </>
                        )}
                        {' '}
                        {(v.cRows ?? []).map((r: any, r_i: number) => (
                          <Fragment key={r_i}>
                            {!!(r.isHead) && (
                              <>
                                <div style={sx('padding:8px 10px 4px;font-size:14px;font-weight:800;color:#22272E;border-bottom:1px solid rgba(34,39,46,.1);')}>
                                  <span>{r.head}</span>
                                </div>
                              </>
                            )}
                            {' '}
                            {!!(r.isRow) && (
                              <>
                                <div onClick={r.onPick} style={sx(r.style)} className={hov('background:rgba(79,138,214,.06);')}>
                                  <a href="#" onClick={ck(r.onSel)} style={sx('font-size:16px;color:#2F5C97;text-decoration:none;')}>
                                    <span>{r.selMark}</span>
                                  </a>
                                  {' '}
                                  <span style={sx('display:flex;flex-direction:column;min-width:0;')}>
                                    <span style={sx('font-size:16px;font-weight:700;color:#22272E;overflow-wrap:break-word;')}>
                                      <span translate="no">{r.name}</span>
                                    </span>
                                    <span style={sx('font-size:14px;color:#54606C;overflow-wrap:break-word;')}>
                                      <span>{r.loc}</span>
                                    </span>
                                  </span>
                                  {' '}
                                  {(r.cells ?? []).map((x: any, x_i: number) => (
                                    <Fragment key={x_i}>
                                      <span style={sx(x.s)}>
                                        <span>{x.v}</span>
                                      </span>
                                    </Fragment>
                                  ))}
                                </div>
                              </>
                            )}
                          </Fragment>
                        ))}
                        {' '}
                        {!!(v.cMore) && (
                          <>
                            <a href="#" onClick={ck(v.cLoadMore)} style={sx('display:block;padding:10px;text-align:center;font-size:16px;font-weight:700;color:#2F5C97;text-decoration:none;')}>
                              <span>{v.cMoreLabel}</span>
                            </a>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {' '}
                {!!(v.crmIsOther) && (
                  <>
                    <div style={sx('flex:1 1 auto;min-height:0;overflow:auto;')}>
                      {!!(v.crmIsPipeline) && (
                        <>
                          <div style={sx('display:flex;align-items:center;gap:7px;flex-wrap:wrap;row-gap:5px;margin-bottom:8px;min-width:0;')}>
                            {(v.crmTrackTabs ?? []).map((tk: any, tk_i: number) => (
                              <Fragment key={tk_i}>
                                <a href="#" onClick={ck(tk.onClick)} style={sx(tk.style)}>
                                  <span>{tk.name}</span>
                                </a>
                              </Fragment>
                            ))}
                            {' '}
                            <span style={sx('font-size:14px;font-weight:700;color:#3C454F;white-space:nowrap;')}>
                              <span>{v.crmTrackScope}</span>
                            </span>
                            {' '}
                            <span style={sx('flex:1 1 200px;min-width:0;font-size:14px;color:#54606C;line-height:1.45;text-wrap:pretty;')}>
                              <span>{v.crmTrackNote}</span>
                            </span>
                          </div>
                          {' '}
                          {!!(v.crmHasDeals) && (
                            <>
                              <div style={sx('font-size:14px;color:#54606C;margin-bottom:9px;text-wrap:pretty;')}>
                                <span>{v.crmDragHint}</span>
                              </div>
                            </>
                          )}
                          {!!v.boardLostHas && (
                            <div style={sx('display:flex;align-items:center;gap:5px;flex-wrap:wrap;row-gap:5px;margin-bottom:9px;')}>
                              <span style={sx('font-size:14px;color:#B3261E;font-weight:700;')}>Why was <span>{v.boardLostName}</span> lost?</span>
                              {(v.crmLostReasons ?? []).map((x: any, x_i: number) => (
                                <a key={x_i} href="#" onClick={ck(x.onClick)} style={sx(x.style)}>
                                  <span>{x.n}</span>
                                </a>
                              ))}
                              <a href="#" onClick={ck(v.boardLostCancel)} style={sx('font-size:14px;color:#54606C;text-decoration:none;')}>Cancel</a>
                            </div>
                          )}
                          {' '}
                          <div style={sx('display:grid;grid-template-columns:repeat(auto-fit,minmax(178px,1fr));gap:11px;align-items:start;min-width:0;')}>
                            {(v.crmStages ?? []).map((st: any, st_i: number) => (
                              <Fragment key={st_i}>
                                <div style={sx(st.colStyle)} onDragOver={st.onDragOver} onDragLeave={st.onDragLeave} onDrop={st.onDrop}>
                                  <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:wrap;row-gap:6px;margin-bottom:10px;')}>
                                    <span style={sx(st.dot)} />
                                    {' '}
                                    <span style={sx('font-variant-numeric:tabular-nums;font-size:14px;font-weight:700;letter-spacing:.08em;color:#22272E;')}>
                                      <span>{st.name}</span>
                                    </span>
                                    {' '}
                                    <span style={sx('flex:1;')} />
                                    {' '}
                                    <span style={sx(st.countStyle)}>
                                      <span>{st.count}</span>
                                    </span>
                                  </div>
                                  {' '}
                                  {(st.deals ?? []).map((d: any, d_i: number) => (
                                    <Fragment key={d_i}>
                                      <div draggable={d.draggable} onDragStart={d.drag} onDragEnd={d.dragEnd} title={d.title} data-testid="board-card" style={sx(d.cardStyle)}>
                                        <div style={sx('font-size:16px;font-weight:600;color:#22272E;overflow-wrap:break-word;')}>
                                          <span>{d.name}</span>
                                        </div>
                                        {' '}
                                        <div style={sx('font-size:14px;color:#54606C;margin-top:3px;')}>
                                          <span>{d.meta}</span>
                                        </div>
                                      </div>
                                    </Fragment>
                                  ))}
                                  {' '}
                                  {!!(st.empty) && (
                                    <>
                                      <div style={sx('box-sizing:border-box;background:rgba(34,39,46,.028);border:1px dashed rgba(34,39,46,.18);border-radius:9px;padding:12px 14px;')}>
                                        <div style={sx('font-size:14px;font-weight:700;color:#3C454F;')}>
                                          No deal at this stage
                                        </div>
                                        <div style={sx('font-size:14px;color:#54606C;margin-top:4px;line-height:1.45;text-wrap:pretty;')}>
                                          Deals arrive here when a prospect is started from My day, Companies or Territory, or dragged across from an earlier stage.
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </Fragment>
                            ))}
                          </div>
                        </>
                      )}
                      {' '}
                      {!!(v.crmIsTable) && (
                        <>
                          <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:0;overflow:hidden;')}>
                            <div style={sx('display:flex;align-items:center;gap:6px;flex-wrap:nowrap;white-space:nowrap;padding:7px 10px;border-bottom:1px solid rgba(34,39,46,.1);min-width:0;')}>
                              <input type="text" value={v.crmQuery} onChange={v.crmSearch} placeholder={v.crmSearchPh} style={sx('box-sizing:border-box;flex:1 1 auto;min-width:110px;height:30px;padding:0 12px;border:1px solid rgba(34,39,46,.14);border-radius:8px;background:#F7F3EA;font-size:16px;color:#22272E;font-family:inherit;')} />
                              {' '}
                              {(v.crmFilters ?? []).map((f: any, f_i: number) => (
                                <Fragment key={f_i}>
                                  <a href="#" onClick={ck(f.onClick)} style={sx(f.style)}>
                                    <span>{f.name}</span>
                                  </a>
                                </Fragment>
                              ))}
                              {' '}
                              <input ref={v.importRef} type="file" accept=".csv,text/csv" hidden onChange={v.onImportFile} />
                              <a href="#" onClick={ck(v.crmImport)} style={sx(v.crmGhostStyle)}>
                                Import
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.crmExport)} style={sx(v.crmExportStyle)}>
                                <span>{v.crmExportLabel}</span>
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.crmCreate)} style={sx(v.crmPrimaryStyle)}>
                                <span>{v.crmCreateLabel}</span>
                              </a>
                            </div>
                            {' '}
                            {!!(v.crmHasViews) && (
                              <>
                                <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:7px 10px;border-bottom:1px solid rgba(34,39,46,.09);row-gap:7px;')}>
                                  {(v.crmViews ?? []).map((vw: any, vw_i: number) => (
                                    <Fragment key={vw_i}>
                                      <a href="#" onClick={ck(vw.onClick)} style={sx(vw.style)}>
                                        <span>{vw.name}</span>
                                        <span style={sx(vw.countStyle)}>
                                          <span>{vw.count}</span>
                                        </span>
                                      </a>
                                    </Fragment>
                                  ))}
                                  {' '}
                                  <span style={sx('font-size:14px;color:#54606C;')}>
                                    <span>{v.crmViewNote}</span>
                                  </span>
                                </div>
                              </>
                            )}
                            {' '}
                            {!!(v.crmHasSel) && (
                              <>
                                <div style={sx('display:flex;align-items:center;gap:10px;flex-wrap:wrap;padding:9px 14px;background:rgba(79,138,214,.09);border-bottom:1px solid rgba(47,92,151,.2);flex-wrap:wrap;row-gap:7px;')}>
                                  <span style={sx('font-size:16px;font-weight:700;color:#2F5C97;')}>
                                    <span>{v.crmSelCount}</span>
                                  </span>
                                  {' '}
                                  {(v.crmBulk ?? []).map((bk: any, bk_i: number) => (
                                    <Fragment key={bk_i}>
                                      <a href="#" onClick={ck(bk.onClick)} style={sx(bk.style)}>
                                        <span>{bk.name}</span>
                                      </a>
                                    </Fragment>
                                  ))}
                                  {' '}
                                  <span style={sx('font-size:14px;color:#54606C;min-width:min(100%,130px);flex:1 1 130px;')}>
                                    <span>{v.crmBulkNote}</span>
                                  </span>
                                  {' '}
                                  <a href="#" onClick={ck(v.crmClearSel)} style={sx('font-size:16px;color:#54606C;text-decoration:none;flex:0 1 auto;min-width:0;')}>
                                    Clear
                                  </a>
                                </div>
                              </>
                            )}
                            {/* Restored from production: put archived contacts back. */}
                            {!v.crmHasSel && v.crmArchivedN > 0 && (
                              <div data-testid="crm-archived" style={sx('display:flex;align-items:center;gap:10px;padding:7px 14px;background:rgba(34,39,46,.04);border-bottom:1px solid rgba(34,39,46,.1);')}>
                                <span style={sx('font-size:14px;color:#54606C;flex:1 1 auto;')}>{v.crmBulkNote}</span>
                                <a href="#" onClick={ck(v.crmRestoreArchived)} style={sx('font-size:16px;font-weight:700;color:#2F5C97;text-decoration:none;')}>Restore</a>
                              </div>
                            )}
                            {' '}
                            <div style={sx(v.crmHeadGrid)}>
                              {(v.crmCols ?? []).map((c: any, c_i: number) => (
                                <Fragment key={c_i}>
                                  <span style={sx(c.style)}>
                                    <span>{c.name}</span>
                                  </span>
                                </Fragment>
                              ))}
                            </div>
                            {' '}
                            {(v.crmRows ?? []).map((r: any, r_i: number) => (
                              <Fragment key={r_i}>
                                <div onClick={r.onClick} style={sx(r.wrap)}>
                                  <a href="#" onClick={ck(r.onSel)} style={sx(r.selStyle)}>
                                    <span>{r.selMark}</span>
                                  </a>
                                  {' '}
                                  {(r.cells ?? []).map((x: any, x_i: number) => (
                                    <Fragment key={x_i}>
                                      <span style={sx(x.style)}>
                                        <span>{x.v}</span>
                                      </span>
                                    </Fragment>
                                  ))}
                                </div>
                              </Fragment>
                            ))}
                            {' '}
                            {!!(v.crmEmpty) && (
                              <>
                                <div style={sx('font-size:16px;color:#54606C;padding:30px 14px;text-align:center;')}>
                                  <span>{v.crmEmptyNote}</span>
                                </div>
                              </>
                            )}
                            {' '}
                            <div style={sx('display:flex;align-items:center;gap:10px;flex-wrap:wrap;row-gap:8px;padding:10px 14px;border-top:1px solid rgba(34,39,46,.08);')}>
                              <span style={sx('font-variant-numeric:tabular-nums;font-size:14px;color:#3C454F;white-space:nowrap;')}>
                                <span>{v.crmPageLabel}</span>
                              </span>
                              {' '}
                              <span style={sx('font-size:14px;color:#54606C;white-space:nowrap;')}>
                                <span>{v.crmPageOf}</span>
                              </span>
                              {' '}
                              <span style={sx('flex:1 1 130px;min-width:min(100%,130px);')} />
                              {' '}
                              <a href="#" aria-disabled={!v.crmHasPrev || undefined} title={v.crmHasPrev ? undefined : 'This is the first page'} onClick={ck(v.crmPrev)} style={sx(v.crmPrevStyle)}>
                                &larr; Prev
                              </a>
                              {' '}
                              <a href="#" aria-disabled={!v.crmHasNext || undefined} title={v.crmHasNext ? undefined : 'This is the last page'} onClick={ck(v.crmNext)} style={sx(v.crmNextStyle)}>
                                Next &rarr;
                              </a>
                            </div>
                            {' '}
                            <div style={sx('font-size:14px;color:#54606C;padding:11px 14px;border-top:1px solid rgba(34,39,46,.08);line-height:1.55;')}>
                              <span>{v.crmFoot}</span>
                            </div>
                          </div>
                        </>
                      )}
                      {' '}
                      {!!(v.crmIsPanel) && (
                        <>
                          <div style={sx('display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:12px;margin-bottom:13px;')}>
                            {(v.crmPanelTiles ?? []).map((t: any, t_i: number) => (
                              <Fragment key={t_i}>
                                <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:12px 15px;')}>
                                  <div style={sx('font-size:14px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#54606C;margin-bottom:6px;')}>
                                    <span>{t.label}</span>
                                  </div>
                                  {' '}
                                  <div style={sx(t.figStyle)}>
                                    <span>{t.fig}</span>
                                  </div>
                                  {' '}
                                  <div style={sx('font-size:14px;color:#54606C;margin-top:6px;')}>
                                    <span>{t.note}</span>
                                  </div>
                                </div>
                              </Fragment>
                            ))}
                          </div>
                          {' '}
                          <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:14px 16px;')}>
                            <div style={sx('font-size:16px;font-weight:700;margin-bottom:8px;')}>
                              <span>{v.crmPanelName}</span>
                            </div>
                            {' '}
                            <div style={sx('font-size:16px;color:#54606C;line-height:1.6;')}>
                              <span>{v.crmPanelNote}</span>
                            </div>
                            {' '}
                            {(v.crmPanelRows ?? []).map((r: any, r_i: number) => (
                              <Fragment key={r_i}>
                                <div style={sx('display:flex;align-items:center;gap:11px;flex-wrap:wrap;row-gap:6px;padding:9px 0;border-top:1px solid rgba(34,39,46,.07);')}>
                                  <span style={sx('min-width:min(100%,130px);flex:1 1 130px;')}>
                                    <span style={sx('display:block;font-size:16px;font-weight:600;color:#22272E;')}>
                                      <span>{r.k}</span>
                                    </span>
                                    {' '}
                                    <span style={sx('display:block;font-size:14px;color:#54606C;margin-top:2px;')}>
                                      <span>{r.note}</span>
                                    </span>
                                  </span>
                                  {' '}
                                  <span style={sx(r.vStyle)}>
                                    <span>{r.v}</span>
                                  </span>
                                </div>
                              </Fragment>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
              {' '}
              {!!(v.crmShowPanel) && (
                <>
                  <div style={sx(v.crmPanelStyle)}>
                    {!!(v.crmNarrow) && (
                      <>
                        <a href="#" onClick={ck(v.crmPanelClose)} aria-label="Close panel" style={sx('align-self:flex-end;display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:7px;border:1px solid rgba(34,39,46,.18);font-size:16px;color:#22272E;text-decoration:none;')}>
                          &#10005;
                        </a>
                      </>
                    )}
                    {' '}
                    {!!(v.crmPanelDeal) && (
                      <>
                        {!!(v.crmNoSel2) && (
                          <>
                            {!!(v.crmTopProHas) && (
                              <>
                                <div style={sx('display:flex;flex-direction:column;gap:8px;padding:4px 2px;animation:riseIn .3s cubic-bezier(.22,.61,.36,1) both;')}>
                                  <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                                    Start here &#183; top of Not started yet
                                  </span>
                                  {' '}
                                  <span style={sx('font-size:16px;font-weight:800;color:#22272E;line-height:1.25;')}>
                                    <span>{v.crmTopPro.name}</span>
                                  </span>
                                  {' '}
                                  <span style={sx('font-size:16px;color:#54606C;line-height:1.5;')}>
                                    <span>{v.crmTopPro.meta}</span>
                                  </span>
                                  {' '}
                                  <span style={sx('display:flex;align-items:baseline;gap:7px;flex-wrap:wrap;')}>
                                    <span style={sx('font-size:22px;font-weight:800;color:#1F6B52;font-variant-numeric:tabular-nums;')}>
                                      <span>{v.crmTopPro.amount}</span>
                                    </span>
                                    {v.crmTopPro.modeled && (
                                      <BuildLabel><span style={sx('font-size:14px;font-weight:800;letter-spacing:.07em;color:#8A5A00;background:rgba(165,86,26,.13);border-radius:3px;padding:2px 5px;')}>
                                        MODELED
                                      </span></BuildLabel>
                                    )}
                                    <span style={sx('font-size:14px;color:#54606C;')}>
                                      uncaptured
                                    </span>
                                  </span>
                                  {' '}
                                  <div style={sx('display:flex;gap:6px;flex-wrap:wrap;')}>
                                    <a href="#" onClick={ck(v.crmTopPro.onStart)} style={sx('display:inline-flex;align-items:center;height:32px;padding:0 13px;border-radius:7px;background:#22272E;color:#F7F3EA;font-size:16px;font-weight:700;text-decoration:none;white-space:nowrap;')}>
                                      Start deal
                                    </a>
                                  </div>
                                  {' '}
                                  {!!(v.crmTopPro.hasWhy) && (
                                    <>
                                      <div style={sx('display:flex;flex-direction:column;gap:6px;padding-top:8px;border-top:1px solid rgba(34,39,46,.1);')}>
                                        <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                                          Why call now
                                        </span>
                                        <span style={sx('font-size:16px;color:#22272E;line-height:1.5;text-wrap:pretty;')}>
                                          <span>{v.crmTopPro.why}</span>
                                        </span>
                                        {!!(v.crmTopPro.hasFlags) && (
                                          <>
                                            <div style={sx('display:flex;gap:5px;flex-wrap:wrap;')}>
                                              {(v.crmTopPro.flags ?? []).map((g: any, g_i: number) => (
                                                <Fragment key={g_i}>
                                                  <span style={sx(g.style)}>
                                                    <span>{g.n}</span>
                                                  </span>
                                                </Fragment>
                                              ))}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )}
                                  {' '}
                                  <div style={sx('display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:1px;background:rgba(34,39,46,.1);border-radius:8px;overflow:hidden;margin-top:4px;')}>
                                    {(v.crmProsStats ?? []).map((k: any, k_i: number) => (
                                      <Fragment key={k_i}>
                                        <div style={sx('display:flex;flex-direction:column;gap:2px;padding:8px 10px;background:#F7F3EA;min-width:0;')}>
                                          <span style={sx('font-size:14px;color:#54606C;overflow-wrap:break-word;')}>
                                            <span>{k.k}</span>
                                          </span>
                                          {/* Wraps rather than clips: "partner@ → deals@" must read in full on a narrow panel. */}
                                          <span title={k.v} data-testid="crm-pros-stat" style={sx('font-size:14px;font-weight:800;color:#22272E;font-variant-numeric:tabular-nums;white-space:normal;overflow-wrap:anywhere;line-height:1.25;')}>
                                            <span>{k.v}</span>
                                          </span>
                                        </div>
                                      </Fragment>
                                    ))}
                                  </div>
                                  {' '}
                                  <span style={sx('font-size:14px;color:#54606C;line-height:1.5;')}>
                                    Or pick any deal on the left to see its history, owner and next step.
                                  </span>
                                </div>
                              </>
                            )}
                            {!!(v.crmTopProNone) && (
                              <>
                                <div style={sx('padding:14px 4px;font-size:16px;color:#54606C;line-height:1.55;')}>
                                  Pick a deal to see its history, owner and next step.
                                </div>
                              </>
                            )}
                          </>
                        )}
                        {' '}
                        {!!(v.crmHasSel2) && (
                          <>
                            <div style={sx('display:flex;flex-direction:column;gap:3px;')}>
                              <span style={sx('font-size:16px;font-weight:800;color:#22272E;line-height:1.25;')}>
                                <span>{v.crmD.name}</span>
                              </span>
                              {' '}
                              <span style={sx('font-size:14px;color:#54606C;')}>
                                <span>{v.crmD.meta}</span>
                              </span>
                              {' '}
                              {!!(v.crmD.hasWhy) && (
                                <>
                                  <span style={sx('font-size:14px;color:#3C454F;line-height:1.45;')}>
                                    <span>{v.crmD.why}</span>
                                  </span>
                                </>
                              )}
                            </div>
                            {' '}
                            <div style={sx(v.crmStepGrid)}>
                              {(v.crmD.steps ?? []).map((x: any, x_i: number) => (
                                <Fragment key={x_i}>
                                  <span style={sx('display:flex;flex-direction:column;gap:4px;min-width:0;')}>
                                    <span style={sx(x.bar)} />
                                    <span style={sx(x.lab)}>
                                      <span>{x.n}</span>
                                    </span>
                                  </span>
                                </Fragment>
                              ))}
                            </div>
                            {' '}
                            <div style={sx('display:flex;gap:16px;flex-wrap:wrap;row-gap:4px;font-size:16px;')}>
                              <span style={sx('display:flex;gap:5px;')}>
                                <span style={sx('color:#54606C;')}>
                                  Stage
                                </span>
                                <span style={sx('font-weight:700;')}>
                                  <span>{v.crmD.stage}</span>
                                </span>
                              </span>
                              {' '}
                              <span style={sx('display:flex;gap:5px;')}>
                                <span style={sx('color:#54606C;')}>
                                  Owner
                                </span>
                                <span style={sx('font-weight:700;')}>
                                  <span>{v.crmD.owner}</span>
                                </span>
                              </span>
                              {' '}
                              <span style={sx('display:flex;gap:5px;align-items:center;')}>
                                <span style={sx('color:#54606C;')}>
                                  Value
                                </span>
                                <span style={sx('font-weight:700;font-variant-numeric:tabular-nums;')}>
                                  <span>{v.crmD.amount}</span>
                                </span>
                                {!!v.crmD.modeled && (
                                  <BuildLabel><span style={sx('font-size:14px;font-weight:800;letter-spacing:.07em;color:#264C7E;background:rgba(47,92,151,.12);border-radius:3px;padding:1px 4px;')}>
                                    MODELED
                                  </span></BuildLabel>
                                )}
                              </span>
                            </div>
                            {' '}
                            <div style={sx('display:flex;gap:5px;flex-wrap:wrap;')}>
                              <a href={v.crmD.mail} onClick={v.crmD.onEmail} style={sx(v.crmD.prim)}>
                                Email
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.crmD.onCall)} title={v.crmD.writeTitle} style={sx(v.crmD.ghost)}>
                                Log call
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.crmD.onMeet)} title={v.crmD.writeTitle} style={sx(v.crmD.ghost)}>
                                Log meeting
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.crmD.onMp)} style={sx(v.crmD.ghostRead)}>
                                Prep for meeting
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.crmD.onPrep)} style={sx(v.crmD.ghostRead)}>
                                Prep one-pager
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.crmD.onLost)} title={v.crmD.writeTitle} style={sx(v.crmD.ghost)}>
                                Mark lost
                              </a>
                            </div>
                            {v.crmD.id && <DealExtras dealId={v.crmD.id} writable={!!v.crmD.writable} writeTitle={v.crmD.writeTitle} />}
                            {' '}
                            {!!(v.crmLostOpen) && (
                              <>
                                <div style={sx('display:flex;align-items:center;gap:5px;flex-wrap:wrap;row-gap:5px;')}>
                                  <span style={sx('font-size:14px;color:#B3261E;font-weight:700;')}>
                                    Why was it lost?
                                  </span>
                                  {(v.crmLostReasons ?? []).map((x: any, x_i: number) => (
                                    <Fragment key={x_i}>
                                      <a href="#" onClick={ck(x.onClick)} style={sx(x.style)}>
                                        <span>{x.n}</span>
                                      </a>
                                    </Fragment>
                                  ))}
                                </div>
                              </>
                            )}
                            {' '}
                            <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:wrap;row-gap:4px;')}>
                              <span style={sx('font-size:16px;color:#54606C;')}>
                                Next meeting
                              </span>
                              {' '}
                              <input type="date" value={v.crmD.meet} onChange={v.crmD.onMeetDate} style={sx('height:28px;box-sizing:border-box;padding:0 8px;border-radius:7px;border:1px solid rgba(34,39,46,.2);background:#FCFAF4;font:inherit;font-size:16px;color:#22272E;')} />
                              {' '}
                              <span style={sx('font-size:14px;color:#54606C;')}>
                                <span>{v.crmD.meetNote}</span>
                              </span>
                            </div>
                            {' '}
                            <div style={sx('display:flex;gap:6px;')}>
                              <input type="text" value={v.crmD.note} onChange={v.crmD.onNote} placeholder="Add a note to this deal&hellip;" style={sx('flex:1 1 auto;min-width:0;height:30px;box-sizing:border-box;padding:0 10px;border-radius:7px;border:1px solid rgba(34,39,46,.2);background:#FCFAF4;font:inherit;font-size:16px;color:#22272E;')} />
                              {' '}
                              <a href="#" aria-disabled={!v.crmD.note.trim() || undefined} onClick={ck(v.crmD.onAddNote)} title={v.crmD.writeTitle || (v.crmD.note.trim() ? undefined : 'Type a note first')} style={sx(v.crmD.ghost)}>
                                Add
                              </a>
                            </div>
                            {' '}
                            <div style={sx('display:flex;gap:6px;align-items:baseline;flex-wrap:wrap;font-size:16px;')}>
                              <span style={sx('color:#54606C;')}>
                                Connection
                              </span>
                              <span style={sx('font-weight:700;color:#22272E;')}>
                                <span>{v.mxDealConn}</span>
                              </span>
                            </div>
                            {' '}
                            {!!(v.mxSumHas) && (
                              <>
                                <div style={sx('display:flex;flex-direction:column;gap:6px;padding:9px 10px;border-radius:9px;background:rgba(79,138,214,.08);')}>
                                  <div style={sx('display:flex;align-items:center;gap:6px;')}>
                                    <span style={sx('font-size:14px;font-weight:800;letter-spacing:.07em;color:#264C7E;background:rgba(47,92,151,.14);border-radius:3px;padding:2px 5px;')}>
                                      ATLAS DRAFT
                                    </span>
                                    <span style={sx('font-size:14px;color:#54606C;')}>
                                      latest email thread, summarized
                                    </span>
                                  </div>
                                  {' '}
                                  <span style={sx('font-size:16px;color:#22272E;line-height:1.5;text-wrap:pretty;')}>
                                    <span>{v.mxSumText}</span>
                                  </span>
                                  {' '}
                                  <span style={sx('font-size:16px;font-weight:700;color:#22272E;')}>
                                    <span>{v.mxSumTask}</span>
                                  </span>
                                  {' '}
                                  {!!(v.mxSumPending) && (
                                    <>
                                      <div style={sx('display:flex;gap:6px;')}>
                                        <a href="#" onClick={ck(v.mxSumAccept)} style={sx('display:inline-flex;align-items:center;height:28px;padding:0 11px;border-radius:7px;font-size:16px;font-weight:700;text-decoration:none;color:#fff;background:#2F5C97;')}>
                                          Accept task
                                        </a>
                                        <a href="#" onClick={ck(v.mxSumReject)} style={sx('display:inline-flex;align-items:center;height:26px;padding:0 9px;border-radius:7px;font-size:14px;font-weight:700;text-decoration:none;white-space:nowrap;color:#22272E;border:1px solid rgba(34,39,46,.22);height:28px;')}>
                                          Dismiss
                                        </a>
                                      </div>
                                    </>
                                  )}
                                  {' '}
                                  {!!(v.mxSumAccepted) && (
                                    <>
                                      <span style={sx('font-size:16px;font-weight:700;color:#1F6B52;')}>
                                        &#10003; Task added to My day and this deal&rsquo;s history
                                      </span>
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                            {' '}
                            <div style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                              History
                            </div>
                            {' '}
                            {!!(v.crmD.noTimeline) && (
                              <>
                                <div style={sx('font-size:16px;color:#54606C;line-height:1.5;')}>
                                  Nothing filed yet. Emails land here when you BCC deals@aithoracare.com; calls and meetings when you log them.
                                </div>
                              </>
                            )}
                            {' '}
                            <div style={sx('display:flex;flex-direction:column;gap:7px;')}>
                              {(v.crmD.timeline ?? []).map((a: any, a_i: number) => (
                                <Fragment key={a_i}>
                                  <div style={sx('display:flex;gap:8px;align-items:flex-start;animation:riseIn .25s cubic-bezier(.22,.61,.36,1);')}>
                                    <span style={sx(a.kStyle)}>
                                      <span>{a.kind}</span>
                                    </span>
                                    <span style={sx('display:flex;flex-direction:column;gap:1px;min-width:0;')}>
                                      <span style={sx('font-size:16px;color:#22272E;line-height:1.4;')}>
                                        <span>{a.text}</span>
                                      </span>
                                      <span style={sx('font-size:14px;color:#54606C;')}>
                                        <span>{a.when}</span>
                                      </span>
                                    </span>
                                  </div>
                                </Fragment>
                              ))}
                            </div>
                          </>
                        )}
                      </>
                    )}
                    {' '}
                    {!!(v.crmPanelCat) && (
                      <>
                        {!!(v.cPickNone) && (
                          <>
                            <div style={sx('padding:14px 4px;font-size:16px;color:#54606C;line-height:1.55;')}>
                              Pick a facility to see it here. Tick several to act on them together.
                            </div>
                          </>
                        )}
                        {' '}
                        {!!(v.cPickHas) && (
                          <>
                            <div style={sx('display:flex;flex-direction:column;gap:3px;')}>
                              <span style={sx('font-size:16px;font-weight:800;color:#22272E;line-height:1.25;')}>
                                <span>{v.cP.name}</span>
                              </span>
                              <span style={sx('font-size:14px;color:#54606C;')}>
                                <span>{v.cP.loc}</span>
                              </span>
                            </div>
                            {' '}
                            <div style={sx('display:flex;align-items:center;gap:7px;')}>
                              <span style={sx('font-size:18px;font-weight:800;font-variant-numeric:tabular-nums;')}>
                                <span>{v.cP.open}</span>
                              </span>
                              {!!v.cP.modeled && (
                                <BuildLabel><span style={sx('font-size:14px;font-weight:800;letter-spacing:.07em;color:#264C7E;background:rgba(47,92,151,.12);border-radius:3px;padding:1px 4px;')}>
                                  MODELED
                                </span></BuildLabel>
                              )}
                              <span style={sx('font-size:14px;color:#54606C;')}>
                                <span>{v.cP.tier}</span>
                              </span>
                            </div>
                            {' '}
                            <div style={sx('display:flex;flex-direction:column;gap:5px;')}>
                              {(v.cP.facts ?? []).map((f: any, f_i: number) => (
                                <Fragment key={f_i}>
                                  <div style={sx('display:grid;grid-template-columns:86px minmax(0,1fr);gap:8px;')}>
                                    <span style={sx('font-size:14px;color:#54606C;')}>
                                      <span>{f.k}</span>
                                    </span>
                                    <span style={sx('font-size:16px;color:#22272E;')}>
                                      <span>{f.v}</span>
                                    </span>
                                  </div>
                                </Fragment>
                              ))}
                            </div>
                            {' '}
                            <div style={sx('display:flex;gap:5px;flex-wrap:wrap;')}>
                              <a href="#" onClick={ck(v.cP.onDeal)} style={sx(v.cP.primary)}>
                                <span>{v.cP.dealLabel}</span>
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.cP.onMp)} style={sx(v.cP.ghost)}>
                                Prep for meeting
                              </a>
                              {' '}
                              <a href="#" onClick={ck(v.cP.onMap)} style={sx(v.cP.ghost)}>
                                Show on map
                              </a>
                            </div>
                            {' '}
                            <div style={sx('font-size:14px;color:#54606C;line-height:1.45;')}>
                              <span>{v.cP.src}</span>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
            {' '}
            <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:wrap;row-gap:4px;font-size:14px;color:#54606C;')}>
              <span style={sx('width:7px;height:7px;border-radius:50%;background:#2F8A6F;animation:pulse 2s ease-in-out infinite;')} />
              {' '}
              <span style={sx('min-width:0;flex:1 1 auto;overflow-wrap:break-word;')} title="BCC or forward to deals@aithoracare.com and it files to the deal">
                <b style={sx('color:#22272E;')}>
                  Email filing on
                </b>
                {' '}&#183; CC partner@ for the facility &#183; BCC deals@ to file
              </span>
              {' '}
              <span style={sx('flex:1;')} />
              {' '}
              <a href="#" onClick={ck(v.mxOpenBtn)} style={sx('color:#54606C;text-decoration:none;')}>
                <span>{v.mxFooter}</span>
              </a>
            </div>
          </div>
      {!!(v.crmContactOpen) && (
        <>
          <div data-screen-label="Contact record" style={sx('position:fixed;inset:0;z-index:60;display:flex;justify-content:flex-end;')}>
            <a href="#" onClick={ck(v.crmContactClose)} style={sx('flex:1 1 130px;min-width:min(100%,130px);background:rgba(34,39,46,.3);text-decoration:none;')} />
            {' '}
            <div style={sx('width:560px;max-width:94vw;flex:0 0 auto;background:#FBF8F1;border-left:1px solid rgba(34,39,46,.16);box-shadow:-16px 0 44px rgba(34,39,46,.16);display:flex;flex-direction:column;')}>
              <div style={sx('flex:0 1 auto;min-width:0;display:flex;align-items:flex-start;gap:12px;padding:15px 18px;border-bottom:1px solid rgba(34,39,46,.11);')}>
                <span style={sx(v.crmContactAvatar)}>
                  <span>{v.crmContactInitials}</span>
                </span>
                {' '}
                <span style={sx('flex:1 1 130px;min-width:min(100%,130px);')}>
                  <span style={sx('display:block;font-size:16px;font-weight:700;line-height:1.3;')}>
                    <span>{v.crmContactName}</span>
                  </span>
                  {' '}
                  <span style={sx('display:block;font-size:16px;color:#54606C;margin-top:3px;')}>
                    <span>{v.crmContactKind}</span>
                  </span>
                </span>
                {' '}
                <a href="#" onClick={ck(v.crmContactClose)} style={sx('display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:7px;border:1px solid rgba(34,39,46,.16);color:#54606C;font-size:16px;text-decoration:none;flex:0 0 28px;')}>
                  &times;
                </a>
              </div>
              {' '}
              <div style={sx('flex:1;min-height:0;overflow:auto;padding:15px 18px;')}>
                <div style={sx('display:flex;align-items:center;gap:9px;flex-wrap:wrap;row-gap:7px;margin-bottom:10px;')}>
                  <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                    Identity
                  </span>
                  {' '}
                  <span style={sx('flex:1 1 130px;min-width:min(100%,130px);')} />
                  {' '}
                  <a href="#" onClick={ck(v.crmCtToggleEdit)} style={sx(v.crmCtEditStyle)}>
                    <span>{v.crmCtEditLabel}</span>
                  </a>
                  {' '}
                  <a href="#" onClick={ck(v.crmCtDelete)} style={sx(v.crmCtDeleteStyle)}>
                    Delete
                  </a>
                </div>
                {' '}
                {!!(v.crmCtConfirming) && (
                  <>
                    <div style={sx('box-sizing:border-box;background:rgba(179,38,30,.08);border:1px solid rgba(179,38,30,.34);border-radius:9px;padding:11px 13px;margin-bottom:11px;')}>
                      <div style={sx('font-size:16px;font-weight:600;color:#B3261E;')}>
                        Delete this contact?
                      </div>
                      {' '}
                      <div style={sx('font-size:14px;color:#54606C;margin-top:4px;')}>
                        It disappears from the Contacts table for this session. The underlying CMS/NPPES record is untouched.
                      </div>
                      {' '}
                      <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:wrap;row-gap:6px;margin-top:10px;')}>
                        <a href="#" onClick={ck(v.crmCtConfirmDelete)} style={sx(v.crmCtDeleteStyle)}>
                          Yes, delete
                        </a>
                        {' '}
                        <a href="#" onClick={ck(v.crmCtCancelDelete)} style={sx('font-size:14px;color:#2F5C97;text-decoration:none;')}>
                          Cancel
                        </a>
                      </div>
                    </div>
                  </>
                )}
                {' '}
                <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:12px 14px;')}>
                  {(v.crmCtIdentity ?? []).map((f: any, f_i: number) => (
                    <Fragment key={f_i}>
                      <div style={sx('display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;row-gap:5px;padding:7px 0;border-bottom:1px solid rgba(34,39,46,.06);')}>
                        <span style={sx('flex:0 1 auto;min-width:0;width:84px;font-size:14px;color:#54606C;')}>
                          <span>{f.label}</span>
                        </span>
                        {' '}
                        {!!(v.crmCtEditing) && (
                          <>
                            <input type="text" value={f.fieldVal} onChange={f.onInput} placeholder={f.placeholder} style={sx('box-sizing:border-box;flex:1 1 130px;min-width:min(100%,130px);height:30px;padding:0 10px;border:1px solid rgba(34,39,46,.18);border-radius:7px;background:#FBF8F1;font-size:16px;color:#22272E;')} />
                          </>
                        )}
                        {' '}
                        {!!(v.crmCtNotEditing) && (
                          <>
                            <span style={sx('flex:1 1 130px;min-width:min(100%,130px);')} />
                            {' '}
                            <span style={sx(f.valStyle)}>
                              <span>{f.val}</span>
                            </span>
                          </>
                        )}
                      </div>
                    </Fragment>
                  ))}
                  {' '}
                  <div style={sx('font-size:14px;color:#54606C;margin-top:9px;text-wrap:pretty;')}>
                    <span>{v.crmCtIdentityNote}</span>
                  </div>
                </div>
                {v.crmCtId && <ContactSmsConsent contactId={v.crmCtId} phoneKey={v.crmCtPhoneKey} writable={!!v.crmCtWritable} writeTitle={v.crmCtWriteTitle} />}
                {' '}
                <div style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;margin:15px 0 9px;')}>
                  Linked company
                </div>
                {' '}
                <a href="#" onClick={ck(v.crmCtCompanyOpen)} style={sx('display:flex;align-items:center;gap:10px;flex-wrap:wrap;row-gap:6px;box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:11px 13px;text-decoration:none;color:#22272E;')} className={hov('border-color:rgba(47,92,151,.4);')}>
                  <span style={sx('flex:1 1 130px;min-width:min(100%,130px);')}>
                    <span style={sx('display:block;font-size:16px;font-weight:600;')}>
                      <span>{v.crmCtCompany}</span>
                    </span>
                    {' '}
                    <span style={sx('display:block;font-size:14px;color:#54606C;margin-top:3px;')}>
                      <span>{v.crmCtCompanyMeta}</span>
                    </span>
                  </span>
                  {' '}
                  <span style={sx('font-size:14px;color:#2F5C97;white-space:nowrap;')}>
                    Open company &rarr;
                  </span>
                </a>
                {' '}
                <div style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;margin:15px 0 9px;')}>
                  Linked deals
                </div>
                {' '}
                {!!(v.crmCtNoDeals) && (
                  <>
                    <div style={sx('box-sizing:border-box;background:rgba(34,39,46,.028);border:1px dashed rgba(34,39,46,.18);border-radius:9px;padding:12px 14px;')}>
                      <div style={sx('font-size:14px;font-weight:700;color:#3C454F;')}>
                        <span>{v.crmCtNoDealsHead}</span>
                      </div>
                      <div style={sx('font-size:14px;color:#54606C;margin-top:4px;line-height:1.45;text-wrap:pretty;')}>
                        <span>{v.crmCtNoDealsNote}</span>
                      </div>
                      <div style={sx('font-size:14px;color:#2F5C97;font-weight:600;margin-top:6px;')}>
                        <span>{v.crmCtNoDealsNext}</span>
                      </div>
                    </div>
                  </>
                )}
                {' '}
                {(v.crmCtDeals ?? []).map((d: any, d_i: number) => (
                  <Fragment key={d_i}>
                    <div style={sx('display:flex;align-items:center;gap:10px;flex-wrap:wrap;row-gap:6px;box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:11px 13px;margin-bottom:7px;')}>
                      <span style={sx('flex:1 1 130px;min-width:min(100%,130px);font-size:16px;font-weight:600;')}>
                        <span>{d.name}</span>
                      </span>
                      {' '}
                      <span style={sx('font-size:14px;color:#264C7E;background:rgba(79,138,214,.16);border-radius:5px;padding:2px 8px;white-space:nowrap;')}>
                        <span>{d.stage}</span>
                      </span>
                      {' '}
                      <span style={sx('font-size:14px;color:#54606C;white-space:nowrap;')}>
                        <span>{d.note}</span>
                      </span>
                    </div>
                  </Fragment>
                ))}
                {' '}
                <div style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;margin:15px 0 9px;')}>
                  Activity &amp; notes
                </div>
                {' '}
                <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:12px 14px;margin-bottom:10px;')}>
                  <div style={sx('display:flex;align-items:center;gap:6px;flex-wrap:wrap;row-gap:6px;margin-bottom:8px;')}>
                    {(v.crmCtKinds ?? []).map((k: any, k_i: number) => (
                      <Fragment key={k_i}>
                        <a href="#" onClick={ck(k.onClick)} style={sx(k.style)}>
                          <span>{k.label}</span>
                        </a>
                      </Fragment>
                    ))}
                  </div>
                  {' '}
                  <div style={sx('display:flex;align-items:center;gap:8px;flex-wrap:wrap;row-gap:7px;')}>
                    <input type="text" value={v.crmCtDraft} onChange={v.crmCtSetDraft} placeholder="Log an activity or write a note&hellip;" style={sx('box-sizing:border-box;flex:1 1 130px;min-width:min(100%,130px);height:32px;padding:0 11px;border:1px solid rgba(34,39,46,.18);border-radius:8px;background:#FBF8F1;font-size:16px;color:#22272E;')} />
                    {' '}
                    <a href="#" onClick={ck(v.crmCtAdd)} style={sx(v.crmCtAddStyle)}>
                      Log
                    </a>
                  </div>
                </div>
                {' '}
                {!!(v.crmCtNoActivity) && (
                  <>
                    <div style={sx('box-sizing:border-box;background:rgba(34,39,46,.028);border:1px dashed rgba(34,39,46,.18);border-radius:9px;padding:12px 14px;')}>
                      <div style={sx('font-size:14px;font-weight:700;color:#3C454F;')}>
                        <span>{v.crmCtNoActivityHead}</span>
                      </div>
                      <div style={sx('font-size:14px;color:#54606C;margin-top:4px;line-height:1.45;text-wrap:pretty;')}>
                        <span>{v.crmCtNoActivityNote}</span>
                      </div>
                      <div style={sx('font-size:14px;color:#2F5C97;font-weight:600;margin-top:6px;')}>
                        <span>{v.crmCtNoActivityNext}</span>
                      </div>
                    </div>
                  </>
                )}
                {' '}
                {(v.crmCtTimeline ?? []).map((a: any, a_i: number) => (
                  <Fragment key={a_i}>
                    <div style={sx('display:flex;align-items:flex-start;gap:10px;flex-wrap:wrap;row-gap:6px;padding:9px 0;border-bottom:1px solid rgba(34,39,46,.06);')}>
                      <span style={sx(a.kindStyle)}>
                        <span>{a.kind}</span>
                      </span>
                      {' '}
                      <span style={sx('flex:1 1 130px;min-width:min(100%,130px);')}>
                        <span style={sx('display:block;font-size:16px;color:#22272E;line-height:1.45;')}>
                          <span>{a.text}</span>
                        </span>
                        {' '}
                        <span style={sx('display:block;font-size:14px;color:#54606C;margin-top:3px;')}>
                          <span>{a.when}</span>
                        </span>
                      </span>
                      {' '}
                      <a href="#" onClick={ck(a.onDone)} style={sx(a.doneStyle)}>
                        <span>{a.doneLabel}</span>
                      </a>
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      {' '}
      {!!(v.crmRecOpen) && (
        <>
          <div style={sx('position:fixed;inset:0;z-index:60;display:flex;justify-content:flex-end;')}>
            <a href="#" onClick={ck(v.crmRecClose)} style={sx('flex:1;background:rgba(34,39,46,.3);text-decoration:none;')} />
            {' '}
            <div style={sx('width:560px;max-width:94vw;flex:0 0 auto;background:#FBF8F1;border-left:1px solid rgba(34,39,46,.16);box-shadow:-16px 0 44px rgba(34,39,46,.16);display:flex;flex-direction:column;min-height:0;')}>
              <div style={sx('flex:0 1 auto;min-width:0;display:flex;align-items:flex-start;gap:12px;padding:15px 18px;border-bottom:1px solid rgba(34,39,46,.11);')}>
                <span style={sx(v.crmRecAvatar)}>
                  <span>{v.crmRecInitials}</span>
                </span>
                {' '}
                <span style={sx('min-width:min(100%,130px);flex:1 1 130px;')}>
                  <span style={sx('display:block;font-size:16px;font-weight:700;')}>
                    <span>{v.crmRecName}</span>
                  </span>
                  {' '}
                  <span style={sx('display:block;font-size:16px;color:#54606C;margin-top:3px;')}>
                    <span>{v.crmRecMeta}</span>
                  </span>
                </span>
                {' '}
                <a href="#" onClick={ck(v.crmRecClose)} style={sx('display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:7px;border:1px solid rgba(34,39,46,.16);color:#54606C;text-decoration:none;font-size:16px;flex:0 0 auto;white-space:nowrap;')}>
                  &times;
                </a>
              </div>
              {' '}
              <div style={sx('flex:1;min-height:0;overflow:auto;padding:15px 18px;')}>
                <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:13px 15px;margin-bottom:12px;')}>
                  <div style={sx('display:flex;align-items:center;gap:9px;flex-wrap:wrap;row-gap:6px;margin-bottom:9px;')}>
                    <span style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
                      AI attributes
                    </span>
                    {' '}
                    <span style={sx('flex:1;')} />
                    {' '}
                    <a href="#" onClick={ck(v.crmRecRefresh)} style={sx(v.crmRecRefreshStyle)}>
                      <span>{v.crmRecRefreshLabel}</span>
                    </a>
                  </div>
                  {' '}
                  {(v.crmRecAi ?? []).map((x: any, x_i: number) => (
                    <Fragment key={x_i}>
                      <div style={sx('padding:8px 0;border-top:1px solid rgba(34,39,46,.07);')}>
                        <div style={sx('display:flex;align-items:center;gap:9px;flex-wrap:wrap;row-gap:6px;')}>
                          <span style={sx('font-size:16px;color:#54606C;min-width:min(100%,130px);flex:1 1 130px;')}>
                            <span>{x.k}</span>
                          </span>
                          {' '}
                          <span style={sx(x.vStyle)}>
                            <span>{x.v}</span>
                          </span>
                          {' '}
                          <BuildTagged tag={x.src}><span style={sx(x.srcStyle)}>
                            <span>{x.src}</span>
                          </span></BuildTagged>
                        </div>
                        {' '}
                        {!!(x.hasWhy) && (
                          <>
                            <div style={sx('font-size:14px;color:#54606C;margin-top:4px;line-height:1.5;')}>
                              <span>{x.why}</span>
                            </div>
                          </>
                        )}
                      </div>
                    </Fragment>
                  ))}
                </div>
                {' '}
                <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:13px 15px;margin-bottom:12px;')}>
                  <div style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;margin-bottom:9px;')}>
                    Relationship
                  </div>
                  {' '}
                  {(v.crmRecRel ?? []).map((x: any, x_i: number) => (
                    <Fragment key={x_i}>
                      <div style={sx('display:flex;align-items:center;gap:10px;flex-wrap:wrap;row-gap:6px;padding:8px 0;border-top:1px solid rgba(34,39,46,.07);')}>
                        <span style={sx('font-size:16px;color:#54606C;min-width:min(100%,130px);flex:1 1 130px;')}>
                          <span>{x.k}</span>
                        </span>
                        {' '}
                        <span style={sx(x.vStyle)}>
                          <span>{x.v}</span>
                        </span>
                      </div>
                    </Fragment>
                  ))}
                  {' '}
                  <div style={sx('font-size:14px;color:#54606C;margin-top:10px;line-height:1.55;')}>
                    <span>{v.crmRecRelNote}</span>
                  </div>
                </div>
                {' '}
                <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:13px 15px;margin-bottom:12px;')}>
                  <div style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;margin-bottom:9px;')}>
                    Signals from the last call
                  </div>
                  {' '}
                  {!!(v.crmRecNoCall) && (
                    <>
                      <div style={sx('font-size:16px;color:#54606C;line-height:1.6;')}>
                        <span>{v.crmRecNoCallNote}</span>
                      </div>
                    </>
                  )}
                  {' '}
                  {(v.crmRecSignals ?? []).map((x: any, x_i: number) => (
                    <Fragment key={x_i}>
                      <div style={sx('display:flex;align-items:flex-start;gap:10px;padding:8px 0;border-top:1px solid rgba(34,39,46,.07);')}>
                        <span style={sx(x.chipStyle)}>
                          <span>{x.kind}</span>
                        </span>
                        {' '}
                        <span style={sx('font-size:16px;color:#22272E;min-width:min(100%,130px);flex:1 1 130px;line-height:1.55;')}>
                          <span>{x.text}</span>
                        </span>
                      </div>
                    </Fragment>
                  ))}
                </div>
                {' '}
                <div style={sx('box-sizing:border-box;border-top:1px solid rgba(34,39,46,.14);padding:13px 15px;')}>
                  <div style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;margin-bottom:9px;')}>
                    Activity
                  </div>
                  {' '}
                  {(v.crmRecActivity ?? []).map((x: any, x_i: number) => (
                    <Fragment key={x_i}>
                      <div style={sx('display:flex;gap:11px;padding:8px 0;border-top:1px solid rgba(34,39,46,.07);')}>
                        <span style={sx('flex:0 0 58px;font-size:14px;color:#54606C;')}>
                          <span>{x.when}</span>
                        </span>
                        {' '}
                        <span style={sx('min-width:min(100%,130px);flex:1 1 130px;')}>
                          <span style={sx('display:block;font-size:16px;color:#22272E;')}>
                            <span>{x.what}</span>
                          </span>
                          {' '}
                          <span style={sx('display:block;font-size:14px;color:#54606C;margin-top:2px;')}>
                            <span>{x.who}</span>
                          </span>
                        </span>
                      </div>
                    </Fragment>
                  ))}
                </div>
              </div>
              {' '}
              <div style={sx('flex:0 1 auto;min-width:0;display:flex;align-items:center;gap:10px;flex-wrap:wrap;row-gap:6px;padding:13px 18px;border-top:1px solid rgba(34,39,46,.11);')}>
                <a href="#" onClick={ck(v.crmRecStart)} style={sx(v.crmRecStartStyle)}>
                  <span>{v.crmRecStartLabel}</span>
                </a>
                {' '}
                <a href="#" onClick={ck(v.crmRecLog)} style={sx(v.crmRecLogStyle)}>
                  <span>{v.crmRecLogLabel}</span>
                </a>
                {' '}
                <span style={sx('flex:1;')} />
                {' '}
                <span style={sx('font-size:14px;color:#54606C;')}>
                  <span>{v.crmRecProvenance}</span>
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
